import { cn } from "~/lib/utils";
import { formatCurrencyValue } from "~/utils/functions/formatCurrencyValue";

// // // //

/**
 * Truncates a string to a maximum length, adding ellipsis if needed
 */
function truncateText(text: string, maxLength: number = 20): string {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}

/**
 * TooltipContent
 * Render content for chart tooltip
 */
export function TooltipContent(props: {
    value: number;
    name: string;
    ticker: string;
    icon_url: string;
    protocol_name: string;
    protocol_icon_url: string;
    issuer_name: string;
    issuer_icon_url: string;
}) {
    const { value, name, ticker, icon_url } = props;

    // Determine styling based on value
    const isPositive = value >= 0;
    const valueColor = isPositive ? "text-emerald-500" : "text-red-500";
    const valueBackground = isPositive ? "bg-emerald-50" : "bg-red-50";

    // Format values
    const formattedValue = formatCurrencyValue(Math.abs(value));

    return (
        <div className="flex flex-col select-none p-4 min-w-lg">
            <div className="flex items-start mb-3">
                {/* <ImageLoader
                    src={icon_url}
                    alt={ticker}
                    className="w-8 h-8 rounded-full object-cover border border-border/30 mt-0.5"
                /> */}
                <div className="flex-1">
                    <h3 className="text-base font-semibold text-foreground leading-tight mb-0.5">
                        {name}
                    </h3>
                    <div className="flex items-center">
                        <span className="text-sm font-medium text-muted-foreground">
                            {ticker}
                        </span>
                    </div>
                </div>
            </div>

            {/* Protocol & Issuer Info Container */}
            <div className="grid grid-cols-2 gap-3 mb-3">
                {/* Protocol Info */}
                <div className="flex flex-col px-3.5 py-2.5 bg-muted/20 rounded-md">
                    <span className="text-sm text-muted-foreground font-semibold mb-2">
                        Protocol
                    </span>
                    <div className="flex items-center">
                        {/* <ImageLoader
                            src={props.protocol_icon_url}
                            alt={props.protocol_name}
                            className="w-5 h-5 rounded-full object-cover border border-border/30"
                        /> */}
                        <span
                            className="text-sm font-medium text-foreground truncate"
                            title={props.protocol_name}
                        >
                            {truncateText(props.protocol_name)}
                        </span>
                    </div>
                </div>

                {/* Issuer Info */}
                <div className="flex flex-col px-3.5 py-2.5 bg-muted/20 rounded-md">
                    <span className="text-sm text-muted-foreground font-semibold mb-2">
                        Issuer
                    </span>
                    <div className="flex items-center">
                        {/* <ImageLoader
                            src={props.issuer_icon_url}
                            alt={props.issuer_name}
                            className="w-5 h-5 rounded-full object-cover border border-border/30"
                        /> */}
                        <span
                            className="text-sm font-medium text-foreground truncate"
                            title={props.issuer_name}
                        >
                            {truncateText(props.issuer_name)}
                        </span>
                    </div>
                </div>
            </div>

            {/* Main Value */}
            <div
                className={cn(
                    "flex items-center justify-between px-3.5 py-3 rounded-md",
                    valueBackground,
                )}
            >
                <p className={cn("text-lg font-medium", valueColor)}>
                    Net Flows
                </p>
                <span
                    className={cn("text-lg font-bold tabular-nums", valueColor)}
                >
                    {isPositive ? "+" : "-"}&nbsp;${formattedValue}
                </span>
            </div>
        </div>
    );
}
